import InventoryGroup from "../InventoryGroup";

export default function Inventory({
  includePlayerInventory = true,
  title = "Chest",
  bgImg = "/chest.png",
}) {
  return (
    <div
      className="flex flex-col items-center gap-3 p-5 pixelated"
      style={{
        ...(includePlayerInventory
          ? {
              backgroundImage: `url('${bgImg}')`,
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center top",
            }
          : {
              backgroundColor: "#c6c6c6",
              border: "3px solid #373737",
              borderRadius: "2px",
              boxShadow: "inset 2px 2px 0 #fff, inset -2px -2px 0 #555",
            }),
      }}
    >
      <div
        className="h-[14px] text-left w-full text-[#404040] text-xl"
        style={{
          transform: "translateY(-5px)",
        }}
      >
        {title}
      </div>
      <InventoryGroup type="chest" />
      {includePlayerInventory && (
        <>
          <div
            className="h-[14px] text-left w-full text-[#404040] text-xl"
            style={{
              transform: "translateY(-5px)",
            }}
          >
            Inventory
          </div>
          <InventoryGroup type="inventory" chatTarget />
          <InventoryGroup type="hotbar" />
        </>
      )}
    </div>
  );
}
